"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var column_view_model_1 = require("../model/column-view.model");
var rows_root_view_model_1 = require("../model/rows-root-view.model");
var report_table_view_model_1 = require("../model/report-table-view.model");
var idm_reporting_service_client_js_1 = require("@synisys/idm-reporting-service-client-js");
var row_view_model_1 = require("../model/row-view.model");
var row_type_1 = require("../sis-tabular-report-rows-panel/model/row-type");
var view_element_branch_resolver_1 = require("../../sis-tabular-report-options/resolver/view-element-branch-resolver");
/**
 * ReportDto to ReportTableView parser
 */
var ReportTableViewParser = /** @class */ (function () {
    function ReportTableViewParser(reportDto, reportViewStyles) {
        this.reportDto = reportDto;
        this.reportViewStyles = reportViewStyles;
        this.viewElementBranchResolver = new view_element_branch_resolver_1.ViewElementBranchResolver();
    }
    ReportTableViewParser.fillStyles = function (reportTableView, reportViewStyles) {
        // fill rows styles
        var rowsRootView = reportTableView.rows;
        for (var i = 0; i < rowsRootView.rows.length; i++) {
            ReportTableViewParser.fillRowViewStyles(rowsRootView.rows[i], rowsRootView, reportViewStyles);
        }
        // fill columns styles
        for (var i = 0; i < reportTableView.columns.children.length; i++) {
            if (!(reportTableView.columns.children[i].isNew || reportTableView.columns.children[i].isDefaultNew)) {
                ReportTableViewParser.fillColumnViewStyles(reportTableView.columns.children[i], reportViewStyles);
            }
        }
    };
    ReportTableViewParser.fillRowViewStyles = function (rowView, rowsRootView, reportViewStyles) {
        if (reportViewStyles && reportViewStyles.rowBranchStylesDto) {
            var rowBranchIndex = view_element_branch_resolver_1.ViewElementBranchResolver.getRowElementBranchIndex(rowView, rowsRootView);
            var rowCategoryStyleDto = reportViewStyles.rowBranchStylesDto[rowBranchIndex]
                .categoriesStyle.get(rowView.element.categoryElementDto.categoryPathHolderId);
            if (rowCategoryStyleDto) {
                rowView.rowCategoryStyleDto = rowCategoryStyleDto;
            }
            for (var i = 0; i < rowView.children.length; i++) {
                ReportTableViewParser.fillRowViewStyles(rowView.children[i], rowsRootView, reportViewStyles);
            }
        }
    };
    ReportTableViewParser.fillColumnViewStyles = function (columnView, reportViewStyles) {
        if (reportViewStyles && reportViewStyles.columnBranchStylesDto) {
            var columnBranchIndex = view_element_branch_resolver_1.ViewElementBranchResolver.getColumnElementBranchIndex(columnView);
            var columnStyleDto = void 0;
            if (columnView.element instanceof idm_reporting_service_client_js_1.ColumnCategoryDto) {
                var categoryElement = columnView.element;
                columnStyleDto = reportViewStyles.columnBranchStylesDto[columnBranchIndex]
                    .categoriesStyle.get(categoryElement.categoryElementDto.categoryPathHolderId);
            }
            else {
                columnStyleDto = reportViewStyles.columnBranchStylesDto[columnBranchIndex].measureStyle;
            }
            if (columnStyleDto) {
                columnView.columnStyleDto = columnStyleDto;
            }
            for (var i = 0; i < columnView.children.length; i++) {
                ReportTableViewParser.fillColumnViewStyles(columnView.children[i], reportViewStyles);
            }
        }
    };
    ReportTableViewParser.prototype.parse = function () {
        var rowsRootView = new rows_root_view_model_1.RowsRootView();
        for (var i = 0; i < this.reportDto.rowRootDto.children.length; i++) {
            var rowCategoryDto = this.reportDto.rowRootDto.children[i];
            rowsRootView.add(this.parseRowElement(rowCategoryDto));
        }
        rowsRootView.setIndexes();
        for (var i = 0; i < rowsRootView.rows.length; i++) {
            this.addRowViewStyles(rowsRootView.rows[i], rowsRootView);
        }
        var columns = new column_view_model_1.ColumnView();
        for (var i = 0; i < this.reportDto.columnRootDto.children.length; i++) {
            var columnTreeElementDto = this.reportDto.columnRootDto.children[i];
            columns.add(this.parseColumnElement(columnTreeElementDto));
        }
        for (var i = 0; i < columns.children.length; i++) {
            this.addColumnViewStyles(columns.children[i]);
        }
        return new report_table_view_model_1.ReportTableView(rowsRootView, columns);
    };
    ReportTableViewParser.prototype.addRowViewStyles = function (rowView, rowsRootView) {
        if (this.reportViewStyles && this.reportViewStyles.rowBranchStylesDto) {
            var rowBranchIndex = view_element_branch_resolver_1.ViewElementBranchResolver.getRowElementBranchIndex(rowView, rowsRootView);
            var rowCategoryStyleDto = this.reportViewStyles.rowBranchStylesDto[rowBranchIndex]
                .categoriesStyle.get(rowView.element.categoryElementDto.categoryPathHolderId);
            if (rowCategoryStyleDto) {
                rowView.rowCategoryStyleDto = rowCategoryStyleDto;
            }
            for (var i = 0; i < rowView.children.length; i++) {
                this.addRowViewStyles(rowView.children[i], rowsRootView);
            }
        }
    };
    ReportTableViewParser.prototype.addColumnViewStyles = function (columnView) {
        if (this.reportViewStyles && this.reportViewStyles.columnBranchStylesDto) {
            var columnBranchIndex = view_element_branch_resolver_1.ViewElementBranchResolver.getColumnElementBranchIndex(columnView);
            var columnStyleDto = void 0;
            if (columnView.element instanceof idm_reporting_service_client_js_1.ColumnCategoryDto) {
                var categoryElement = columnView.element;
                columnStyleDto = this.reportViewStyles.columnBranchStylesDto[columnBranchIndex]
                    .categoriesStyle.get(categoryElement.categoryElementDto.categoryPathHolderId);
            }
            else {
                columnStyleDto = this.reportViewStyles.columnBranchStylesDto[columnBranchIndex].measureStyle;
            }
            if (columnStyleDto) {
                columnView.columnStyleDto = columnStyleDto;
            }
            for (var i = 0; i < columnView.children.length; i++) {
                this.addColumnViewStyles(columnView.children[i]);
            }
        }
    };
    ReportTableViewParser.prototype.parseRowElement = function (element) {
        var rowView = new row_view_model_1.RowView();
        rowView.element = element;
        rowView.rowType = row_type_1.RowType.SPECIFIED;
        for (var i = 0; i < element.children.length; i++) {
            var rowCategoryDto = element.children[i];
            rowView.add(this.parseRowElement(rowCategoryDto));
        }
        return rowView;
    };
    ReportTableViewParser.prototype.parseColumnElement = function (element) {
        var columnRootView = new column_view_model_1.ColumnView(element);
        for (var i = 0; i < element.children.length; i++) {
            var columnTreeElementDto = element.children[i];
            columnRootView.add(this.parseColumnElement(columnTreeElementDto));
        }
        return columnRootView;
    };
    return ReportTableViewParser;
}());
exports.ReportTableViewParser = ReportTableViewParser;
//# sourceMappingURL=report-table-view.parser.js.map